import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { finalize, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { ConfirmareDocumenteService } from './confirmare-documente.service';
import { HttpClient } from '@angular/common/http';
import { AppFilesService } from 'src/app/services/app-files.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { MatCalendar } from '@angular/material/datepicker';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { NotificationService } from 'src/app/services/notification.service';
import { DialogService } from 'src/app/services/dialog.service';
import { MatDialog } from '@angular/material/dialog';
import { ViewConfirmationComponent } from './view-confirmation/view-confirmation.component';
import { DocumentConfirmation } from './confirmare-documente.interface';
import { formatDate } from '@angular/common';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-confirmare-documente',
    templateUrl: './confirmare-documente.component.html',
    styleUrls: ['./confirmare-documente.component.scss']
})
export class ConfirmareDocumenteComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    // Popover dates
    @ViewChild(PopoverDirective) popover!: PopoverDirective;
    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;

    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(new Date().getFullYear(), 0, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = 'current_year';

    // Last day of the current year
    lastDayOfYear: Date = new Date(new Date().getFullYear(), 11, 31);
    lastDayOfNextYear: Date = new Date(new Date().getFullYear() + 1, 11, 31);

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.selectedEndDate = this.today;
        this.updateCalendarView(this.endCalendar, this.today);
        this.rerenderDT();
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setToday(): void {
        this.selectedStartDate = this.today;
        this.updateCalendarView(this.startCalendar, this.today);
        this.selectedEndDate = this.today;
        this.updateCalendarView(this.endCalendar, this.today);
        this.rerenderDT();
        this.selectedFilteringButton = `today`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedEndDate = yearsBack === 0 ? this.today : new Date(year, 11, 31);
        this.updateCalendarView(this.endCalendar, this.selectedEndDate);
        this.rerenderDT();
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    setTodayToEndYear(): void {
        this.selectedStartDate = this.today;
        this.updateCalendarView(this.startCalendar, this.today);
        this.selectedEndDate = this.lastDayOfYear;
        this.updateCalendarView(this.endCalendar, this.selectedEndDate);
        this.rerenderDT();
        this.selectedFilteringButton = 'today_to_end_year';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date
    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    isLoading = false;
    isFilterLoading = false;
    showCard = false;

    checkboxSelections = false;
    selectedRowIds: number[] = [];
    selectedDocIds: number[] = [];
    rowCount = 0;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;
    dtParameters: any = {};
    dtInfo: string = '';

    scopParameters: { key: string; value: number }[] = [
        { key: '-- Toate --', value: -1 },
        { key: 'Cu specificație', value: 0 },
        { key: 'Vânzare', value: 1 },
        { key: 'Succesiune', value: 2 },
    ];

    tipDocumentParameters: { key: string; value: number }[] = [
        { key: '-- Toate --', value: -1 },
        { key: 'Transmis', value: 1 },
        { key: 'Generat', value: 2 },
    ];

    parameters: { key: string; value: number }[] = [
        { key: '-- Toate --', value: -1 },
        { key: 'Da', value: 1 },
        { key: 'Nu', value: 0 },
    ];

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.activeFilters = 0;
        this.rerenderDT(true);
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
        this.checkActiveFilters();
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    activeFilters = 0;
    searchParamsForm!: FormGroup;

    //Form Initial Values
    initialFormValues = {
        // scopcf: -1,
        // fara_lista_patrimoniu: -1,
        confirmed: -1,
        numar_solicitare: '',
        cnp_cui: '',
        // rol_id: '',
        full_name: '',
        document_type: -1,
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            // scopcf: new FormControl(-1),
            // fara_lista_patrimoniu: new FormControl(-1),
            confirmed: new FormControl(-1),
            numar_solicitare: new FormControl(''),
            cnp_cui: new FormControl(''),
            // rol_id: new FormControl(''),
            full_name: new FormControl(''),
            document_type: new FormControl(-1),
        });
    }

    checkActiveFilters() {
        this.activeFilters = 0;
        const currentFilters = this.searchParamsForm.value;

        for (const [key, value] of Object.entries(this.initialFormValues)) {
            if (key in currentFilters && currentFilters[key] !== value) {
                this.activeFilters++
            }
        }
    }

    dtLink =
        environment.interop.basePath +
        environment.interop.dgaspc.confirmareDocumente.getDocumenteCofirmareDT;

    constructor(
        private http: HttpClient,
        private dialogService: DialogService,
        private dialog: MatDialog,
        private confirmareDocumenteService: ConfirmareDocumenteService,
        private appFilesService: AppFilesService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
        this.buildSearchParamsForm();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    renderDT() {
        const self = this;

        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,
            order: [1, 'desc'],

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                Object.assign(dataTablesParameters, { ...this.searchParamsForm.value });
                dataTablesParameters.date_from = this.formatDate(this.selectedStartDate);
                dataTablesParameters.date_to = this.formatDate(this.selectedEndDate);

                this.dtParameters = dataTablesParameters;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        this.getTableRowCount();
                        this.checkboxesReset();
                        this.extractRecordsFromDT();

                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: `<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" id="headerCheckbox"/>`,
                    data: null,
                    orderable: false,
                    className: "all",
                    render: (data: any, type: any, row: any) => {
                        return (
                            `
							<div style="display: flex; align-items: center; gap: 5px;">
							    <input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" value="${row.id_confirmare}" />
                            </div>
                            `
                        );
                    },
                },
                {
                    title: 'ID',
                    data: 'id_confirmare',
                },
                {
                    title: 'Solicitare',
                    data: 'cerere_info',
                    orderable: false,
                },
                {
                    title: 'Cetățean',
                    data: 'name',
                    className: 'all',
                    render: (data: any, type: any, row: any) => {
                        return `
                            <div class="d-flex flex-column gap-2">
                                <span>${row.name}</span>
                                <button style="color: #fff;" class="action-btn signatures view-confirmation">
                                    <div class="d-flex gap-1 justify-content-center align-items-center">
                                        <img class="btn-img" src="/assets/icons/public_white.svg" alt="view_confirmation"/>    
                                        <span>CONFIRMĂRI</span>
                                    </div>    
                                </button>
                            </div>
                        `;
                    },
                },
                {
                    title: 'CNP/CUI',
                    data: 'cnp_reprezentant',
                    orderable: false,
                },
                {
                    title: 'Tip document',
                    data: 'document_type_denumire',
                    orderable: false,
                    render: (data: any, type: any, row: any) => {
                        if (row.document_type === null) {
                            return `<span>${row.document_type_denumire}</span>`
                        } else {
                            const imageSendUrl = '/assets/icons/icon-send.svg';
                            const imageBuildingUrl = '/assets/icons/icon-building.svg';
                            const imageFileUrl = '/assets/icons/icon-file.svg';
                            const imageType = row.document_type === 1 ? imageSendUrl : imageBuildingUrl;
                            const docType = row.document_type === 1 ? 'Fișier' : 'Template';
                            const docTypeName = row.document_type === 1 ? row.document_name : row.document_generat;

                            return `
                                <img src="${imageType}" alt="Image" style="width: 20px; height: 20px;">
                                <span>${row.document_type_denumire}</span>
                                <br/>
                                <span style="color:#bdbdbd; font-size:12px">${docType}</span>
                                <br/>
                                <img src="${imageFileUrl}" alt="Image" style="width: 20px; height: 20px;">
                                <span>${docTypeName}</span>
                            `;
                        }
                    },
                },
                {
                    title: 'Status',
                    data: 'status',
                    orderable: false,
                },
                {
                    title: 'Document generat',
                    data: 'created_at',
                    render: (data: any, type: any, row: any) => {
                        const formattedDate = formatDate(row.created_at, 'yyyy-MM-dd HH:mm:ss', 'en-US')
                        return `
                            <span>${formattedDate}</span>
                        `;
                    },
                },
                {
                    title: 'Ultima actualizare',
                    data: 'updated_at',
                    render: (data: any, type: any, row: any) => {
                        const formattedDate = formatDate(row.updated_at, 'yyyy-MM-dd HH:mm:ss', 'en-US')
                        return `
                            <span>${formattedDate}</span>
                        `;
                    },
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: () => {
                        return `
                        <div class="d-flex flex-column gap-2">
                            <button style="color: #fff;" class="action-btn download">
                                DESCARCĂ
                            </button>
                        </div>
                        `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');

                // Handle click event on the CHECKBOXES
                $(row)
                    .find('.row-checkbox')
                    .off('change')
                    .on('change', function () {
                        let idConfirmare = Number($(this).val());
                        let idDoc = data.document_id;

                        if ($(this).is(':checked')) {
                            self.selectedRowIds.push(idConfirmare);
                            self.selectedDocIds.push(idDoc);
                        } else {
                            self.selectedRowIds = self.selectedRowIds.filter(
                                (id) => id !== idConfirmare
                            );
                            self.selectedDocIds = self.selectedDocIds.filter(
                                (id) => id !== idDoc
                            );
                        }

                        if (self.rowCount !== self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(false);
                        } else if (self.rowCount === self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(true);
                        }

                        self.checkboxSelections = self.selectedRowIds.length > 0;
                    });

                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const downloadButton = lastTd?.querySelector('.download') as HTMLElement;

                const citizenTD = (row as HTMLElement).querySelector('td:nth-child(4)');
                const viewConfirmationButton = citizenTD?.querySelector('.view-confirmation') as HTMLElement;

                if (downloadButton) {
                    downloadButton.addEventListener('click', () => {
                        this.downloadDocument(data.document_id);
                    });
                }

                if (viewConfirmationButton) {
                    viewConfirmationButton.addEventListener('click', () => {
                        this.viewConfirmation(data);
                    });
                }

                return row;
            },
            headerCallback: (row: Node, data: any[] | any) => {
                const headerCheckbox = $(row).find('#headerCheckbox');

                // Remove any existing event handlers to avoid duplicating them
                headerCheckbox.off('change click');

                // Handle the change event for selecting/deselecting all checkboxes
                headerCheckbox.on('change', function () {
                    self.selectedRowIds.length = 0;
                    self.selectedDocIds.length = 0;
                    if ($(this).is(':checked')) {
                        data.forEach((item: DocumentConfirmation) => {
                            self.selectedRowIds.push(item.id_confirmare);
                            self.selectedDocIds.push(item.document_id);
                        });
                        self.checkMultipleCheckboxesByValue(true);
                    } else {
                        self.checkMultipleCheckboxesByValue(false);
                    }
                    self.checkboxSelections = self.selectedRowIds.length > 0;
                });

                // Prevent sorting when clicking the checkbox
                headerCheckbox.on('click', function (e) {
                    e.stopPropagation();
                });

                return row;
            },
        };
    }

    async getTableRowCount() {
        const table = await this.dtElement.dtInstance;
        this.rowCount = table.rows().count();
    }

    checkHeaderCheckBox(checkValue: boolean) {
        const headerCheckbox = document.getElementById(
            "headerCheckbox"
        ) as HTMLInputElement;
        headerCheckbox.checked = checkValue;
    }
    checkMultipleCheckboxesByValue(checkValue: boolean) {
        let checkboxes = document.querySelectorAll<HTMLInputElement>(
            'input[type="checkbox"]'
        );
        checkboxes.forEach((checkbox) => {
            checkbox.checked = checkValue;
        });
    }
    checkboxesReset() {
        this.selectedRowIds.length = 0;
        this.selectedDocIds.length = 0;
        this.checkMultipleCheckboxesByValue(false);
        this.checkHeaderCheckBox(false);
        this.checkboxSelections = false;
    }

    rerenderDT(paginate = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });

        this.showCard = false;
    }

    async extractRecordsFromDT() {
        if (this.dtElement && this.dtElement.dtInstance) {
            try {
                const dtInstance = await this.dtElement.dtInstance;
                // Get the actual page info with real values
                const pageInfo = dtInstance.page.info(); // Full page info object

                // Store the actual values
                const dtStart = (pageInfo.start + 1); // + 1 because it starts with 0
                const dtEnd = pageInfo.end;
                const dtRecordsDisplay = pageInfo.recordsDisplay;
                const dtRecordsTotal = pageInfo.recordsTotal;

                this.dtInfo = `Afișate de la ${dtStart} până la ${dtEnd} din ${dtRecordsDisplay} înregistrări`

                // console.log('Actual values:', {
                //     total: this.dtRecordsTotal,
                //     display: this.dtRecordsDisplay,
                //     start: this.dtStart,
                //     end: this.dtEnd,
                //     pageInfo: pageInfo,
                // });

            } catch (error) {
                console.error('Error extracting token values:', error);
            }
        }
    }

    downloadDocument(id: number) {
        let fullPath = this.confirmareDocumenteService.fileDownloadUrl + id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    printDocumente() {
        this.isLoading = true;

        this.confirmareDocumenteService.printDocumente(this.dtParameters)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (response: any) => {
                    let dataType = response.type;
                    let binaryData = [];
                    binaryData.push(response);
                    let downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
                    downloadLink.setAttribute('target', '_blank');
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);

                    // Rerender after download
                    this.rerenderDT();
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    viewConfirmation(data: DocumentConfirmation) {
        const dialogRef = this.dialog.open(ViewConfirmationComponent, {
            width: '700px',
            maxWidth: '80vw',
            minHeight: '200px',
            maxHeight: '90vh',
            autoFocus: false,
            disableClose: true,
            data,
        });
        // dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
        //     if (success) {
        //         this.rerenderDT();
        //     }
        // });
    }

    predareDocumente(data?: number[]) {
        let payload = data ? data : this.selectedRowIds;

        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Confirmați predarea documentelor selectate la sediu?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: helper.swalTextConfig.buttonLabels.close,
            // showLoaderOnConfirm: true,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.confirmareDocumenteService.predareDocumente(payload).subscribe({
                    next: () => {
                        this.rerenderDT();
                        Swal.fire({
                            title: helper.dialogConfig.headers.success,
                            text: 'Documente predate cu succes.',
                            icon: 'success',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        });
                    },
                    error: (err: any) => {
                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: err.error.errors.message[0],
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        })
                    }
                });
            }
        });
    }
}
